import { SHOW_SMALL_BOX, HIDE_SMALL_BOX, FILE_OVERLAYER_SEEN } from './types'

export const showSmallBox = (mapping_id) => dispatch => {
  dispatch({ type: SHOW_SMALL_BOX, visible: true, mapping_id: mapping_id })
}
export const hideSmallBox = () => dispatch => {
  dispatch({ type: HIDE_SMALL_BOX, visible: false, mapping_id: null })
}

export const fileOverlayerSeen = () => dispatch => {
  dispatch({ type: FILE_OVERLAYER_SEEN})
}
